var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer-preview-tile-wrapper"},[_c('div',{staticClass:"timer-preview-tile"},[_c('img',{staticClass:"clock-image",attrs:{"src":'/'+require('../../assets/images/timer-clock/Clock280.png')}}),_c('div',{staticClass:"timer-duration"},[_vm._v(_vm._s(_vm.duration))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }